import * as types from './types';

const initialState = {
  note: null,
  template: null,
  refresh: true,
  error: null,
  loading: false,
};

export default (state = initialState, action) => {
  const newNote = action.payload;
  const newTemplate = action.payload;
  let noteContents;
  const { isBlocking, blockedBy } = newNote || {};

  switch (action.type) {
    case types.GET_NOTE_SUCCESS:
      return {
        ...state,
        note: newNote,
        refresh: false,
      };
    case types.GET_NOTE_FAIL:
      return state;
    case types.GET_TEMPLATE_SUCCESS:
      return {
        ...state,
        template: newTemplate,
        refresh: false,
      };
    case types.BLOCK_NOTE_SUCCESS:
      return {
        ...state,
        note: {
          ...state.note,
          isBlocking: isBlocking ?? state.note.isBlocking,
          blockedBy: blockedBy ?? state.note.blockedBy,
        },
      };
    case types.BLOCK_NOTE_FAIL:
      return state;
    case types.UNBLOCK_NOTE_SUCCESS:
      return {
        ...state,
        note: {
          ...state.note,
          isBlocking: isBlocking ?? state.note.isBlocking,
        },
      };
    case types.UNBLOCK_NOTE_FAIL:
      return state;
    case types.NOTE_FILE_UPLOAD:
      return {
        ...state,
        loading: true,
      };
    case types.NOTE_FILE_REMOVE_SUCCESS:
      // Falls through.
    case types.NOTE_TEMPLATE_FILE_REMOVE_SUCCESS:
      // Falls through.
    case types.NOTE_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        refresh: true,
        loading: false,
      };
    case types.NOTE_FILE_UPLOAD_FAIL:
      return {
        ...state,
        error: {
          message: 'The file was unable to be uploaded. Please try again in a moment or contact support.',
        },
        loading: false,
      };
    case types.NOTE_ERROR_MODAL_CLOSE:
      return {
        ...state,
        error: null,
      };
    case types.RESTRICTIONS_NOTE_SUCCESS:
      return {
        ...state,
        note: {
          ...state.note,
          ...newNote,
        },
      };
    case types.UPDATE_NOTE_SUCCESS:
      return {
        ...state,
        note: newNote,
      };
    case types.UPDATE_NOTE_FAIL:
      return { ...state, error: action.payload };
    case types.UPDATE_NOTE_CONTENT_SUCCESS:
      if (action.payload.note_html) {
        noteContents.note_html = action.payload.note_html;
      }
      if (action.payload.note_json) {
        noteContents.note_json = action.payload.note_json;
      }
      return { ...state, note: { ...state.note, ...noteContents } };
    case types.UPDATE_NOTE_CONTENT_FAIL:
      // Set error
      return state;
    case types.PUSH_NOTE_CHANGE_SUCCESS:
      return { ...state, note: { ...state.note, noteJson: action.payload.noteJson.currentVersion[0] } };
    case types.PUSH_NOTE_CHANGE_FAIL:
      return state;
    case types.UPDATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        template: newTemplate,
      };
    case types.UPDATE_TEMPLATE_CONTENT_SUCCESS:
      if (action.payload.note_html) {
        noteContents.note_html = action.payload.note_html;
      }
      if (action.payload.note_json) {
        noteContents.note_json = action.payload.note_json;
      }
      return { ...state, template: { ...state.template,  ...noteContents } };
    case types.UPDATE_TEMPLATE_CONTENT_FAIL:
      // Set error
      return;
    case types.PUSH_NOTE_TEMPLATE_CHANGE_SUCCESS:
      return { ...state, template: { ...state.template, noteJson: action.payload.noteJson.currentVersion[0] } };
    case types.PUSH_NOTE_TEMPLATE_CHANGE_FAIL:
      return state;
    case types.DELETE_TEMPLATE_SUCCESS:
      // Falls through.
    case types.DELETE_NOTE_SUCCESS:
      return {
        ...state,
        deleteComplete: true,
      };
    default:
      return state;
  }
};
